import { useContext } from 'react';
import { RootStore } from '@store';
import { StoreContext } from '@store/provider';
import { useInstance } from 'react-ioc';

export const useStore = (): RootStore => useInstance(RootStore);
